export const DEAL_STAGES = [
  { id: "lead_generation", label: "Lead Generation", probability: 0.1 },
  { id: "initial_contact", label: "Initial Contact", probability: 0.2 },
  { id: "needs_analysis", label: "Needs Analysis", probability: 0.4 },
  { id: "proposal_sent", label: "Proposal Sent", probability: 0.6 },
  { id: "negotiation", label: "Negotiation", probability: 0.8 },
  { id: "closed_won", label: "Closed Won", probability: 1.0 },
  { id: "closed_lost", label: "Closed Lost", probability: 0 },
] as const;

export type DealStage = typeof DEAL_STAGES[number]["id"];

export const stageLabel = (id: string) => DEAL_STAGES.find(s => s.id === id)?.label ?? id;
export const stageProbability = (id: string) => DEAL_STAGES.find(s => s.id === id)?.probability ?? 0;

export const formatMoney = (cents: number, currency = "GBP") =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency, maximumFractionDigits: 0 }).format((cents ?? 0) / 100);

export const CONTACT_STAGES = ["new", "working", "qualified", "archived"] as const;
